
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    display: block
}

:host([site='GHS']) .location-detail__wrapper {

    display: flex
}

:host([site='GHS']) .location-detail__wrapper {

    border-radius: 0.75rem
}

:host([site='GHS']) .location-detail__wrapper {

    background-color: var(--neutral-white)
}

:host([site='GHS']) .location-detail__wrapper {

    padding: 1rem
}

@media (min-width: 1024px) {

    :host([site='GHS']) .location-detail__wrapper {

        padding: 2rem
    }
}

:host([site='GHS']) ::slotted([slot='location-detail-left-column']) {

    width: 100%
}

:host([site='GHS']) .location-detail__map--image {

    margin-left: 1.5rem
}

:host([site='GHS']) .location-detail__map--image {

    display: none
}

:host([site='GHS']) .location-detail__map--image {

    height: 16rem
}

:host([site='GHS']) .location-detail__map--image {

    width: 16rem
}

:host([site='GHS']) .location-detail__map--image {

    min-width: 16rem
}

:host([site='GHS']) .location-detail__map--image {

    overflow: hidden
}

:host([site='GHS']) .location-detail__map--image {

    border-radius: 1.5rem
}

@media (min-width: 1024px) {

    :host([site='GHS']) .location-detail__map--image {

        display: block
    }
}

:host([site='BH']) .location-detail__wrapper {

    display: flex
}

:host([site='BH']) .location-detail__wrapper {

    border-radius: 0.5rem
}

:host([site='BH']) .location-detail__wrapper {

    border-width: 1px
}

:host([site='BH']) .location-detail__wrapper {

    border-style: solid
}

:host([site='BH']) .location-detail__wrapper {

    border-color: var(--bh-neutral-default)
}

:host([site='BH']) .location-detail__wrapper {

    background-color: var(--bh-neutral-white)
}

:host([site='BH']) .location-detail__wrapper {

    padding: 1rem
}

@media (min-width: 1024px) {

    :host([site='BH']) .location-detail__wrapper {

        padding: 2rem
    }
}

:host([site='BH']) ::slotted([slot='location-detail-left-column']) {

    width: 100%
}

:host([site='BH']) .location-detail__map--image {

    margin-left: 1.5rem
}

:host([site='BH']) .location-detail__map--image {

    display: none
}

:host([site='BH']) .location-detail__map--image {

    height: 16rem
}

:host([site='BH']) .location-detail__map--image {

    width: 16rem
}

:host([site='BH']) .location-detail__map--image {

    min-width: 16rem
}

:host([site='BH']) .location-detail__map--image {

    overflow: hidden
}

:host([site='BH']) .location-detail__map--image {

    border-radius: 0.5rem
}

@media (min-width: 1024px) {

    :host([site='BH']) .location-detail__map--image {

        display: block
    }
}
`;